import { NewAnswerQuizOutDto, GetOneQuizOutDto } from "../../types/quiz.dto";
import { GET_ONE_QUIZ, GetOneQuiz, RESET_GET_ONE_QUIZ } from "../types/quiz/get-one.dto";

import {
  NEW_ANSWER_QUIZ,
  NewAnswerQuiz,
  RESET_NEW_ANSWER_QUIZ,
} from "../types/quiz/new-answer-quiz.dto";

export const getOneQuiz = (payload: GetOneQuizOutDto): GetOneQuiz => {
  return { type: GET_ONE_QUIZ, payload };
};

export const resetGetOneQuiz = () => {
  return { type: RESET_GET_ONE_QUIZ, payload: null };
};

export const newAnswerQuiz = (payload: NewAnswerQuizOutDto): NewAnswerQuiz => {
  return { type: NEW_ANSWER_QUIZ, payload };
};

export const resetNewAnswerQuiz = () => {
  return { type: RESET_NEW_ANSWER_QUIZ, payload: null };
};
